import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import { Theme } from '../theme';
import Container from './Container';
import Content from './Content';
export default class Lozenge extends PureComponent {
  render() {
    const {
      theme,
      children,
      testId
    } = this.props;
    return /*#__PURE__*/React.createElement(Theme.Provider, {
      value: theme
    }, /*#__PURE__*/React.createElement(Theme.Consumer, this.props, themeTokens => /*#__PURE__*/React.createElement(Container, _extends({
      testId: testId
    }, themeTokens), /*#__PURE__*/React.createElement(Content, themeTokens, children))));
  }

}

_defineProperty(Lozenge, "defaultProps", {
  isBold: false,
  appearance: 'default',
  maxWidth: 200
});